"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positiveTabValues = exports.negativeTabValues = exports.priceTabValues = exports.sizeTabOptions = void 0;
exports.sizeTabOptions = [
    { label: '25%', value: 0.25 },
    { label: '50%', value: 0.5 },
    { label: '75%', value: 0.75 },
    { label: 'Max', value: 1 },
];
exports.priceTabValues = [
    { value: 0.01, label: '1%' },
    { value: 0.02, label: '2%' },
    { value: 0.05, label: '5%' },
    { value: 0.1, label: '10%' },
    { value: 0.15, label: '15%' },
];
exports.negativeTabValues = exports.priceTabValues.map((tab) => ({
    label: `-${tab.label}`,
    value: -tab.value,
}));
exports.positiveTabValues = exports.priceTabValues.map((tab) => ({
    label: `+${tab.label}`,
    value: tab.value,
}));
//# sourceMappingURL=tabs.consts.js.map